import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    loadingShowTag: false,
    loadText: '加载中',
    alertShowTag: false,
    alertTitle: '系统提示',
    alertContent: ''
  },
  mutations: {
    showLoading (state, loadText) {
      state.loadingShowTag = true
      if (loadText) {
        state.loadText = loadText
      }
    },
    hideLoading (state) {
      state.loadingShowTag = false
      state.loadText = '加载中'
    },
    showAlert (state, content, title) {
      state.alertShowTag = true
      state.alertContent = content
      if (title) {
        state.alertTitle = title
      }
    },
    hideAlert (state) {
      state.alertShowTag = false
      state.alertTitle = '系统提示'
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js